import React, {Fragment} from 'react';

import {ModalError} from 'presentation/components/ModalError';
import {translations} from 'presentation/translations-new';
import {ShortcutCard} from '../ShortcutCard';
import {useShortcutClick} from './hooks/useShortcutClick';
import {ShortCutProps} from './types';

const {
	title: modalErrorTitle,
	subtitle,
	description,
	tryAgainBtn,
	backAction,
} = translations['pt-br'].others.genericErrorModal;

export function Shortcut({
	icon,
	route,
	title,
	type,
	endpoint,
	isInversedColor,
	featureFlagName,
	dataTagId,
	handleClick,
	warningDrawerContent,
	overrideClick,
	setWarningDrawerContainer,
	isBlob,
	disableCache,
	layoutVariant,
	...cardProps
}: ShortCutProps) {
	const {handleClickAction, isError, setIsError, isLoading} = useShortcutClick({
		title,
		type,
		route,
		endpoint,
		featureFlagName,
		handleClick,
		warningDrawerContent,
		overrideClick,
		setWarningDrawerContainer,
		isBlob,
		disableCache,
	});

	return (
		<Fragment>
			<ShortcutCard
				loading={isLoading}
				handleClick={handleClickAction}
				dataTagId={dataTagId}
				hasEmphasis={isInversedColor}
				icon={icon}
				title={title}
				breakTitle
				layoutVariant={layoutVariant}
				{...cardProps}
			/>
			{isError ? (
				<ModalError
					open={isError}
					onClose={() => setIsError(false)}
					headerTitle={modalErrorTitle}
					title={subtitle}
					isFullScreen={false}
					maxWidth={420}
					description={description}
					firstButton={{
						title: backAction,
						handleClick: () => setIsError(false),
						variant: 'outlined',
					}}
					secondButton={{
						title: tryAgainBtn,
						handleClick: () => {
							setIsError(false);
							handleClickAction();
						},
						variant: 'contained',
					}}
				/>
			) : null}
		</Fragment>
	);
}
